import React, { FunctionComponent } from 'react'
import { tt } from '../../../i18n'
import { useSelector } from 'react-redux'
import {
  currentQuestionIdxSelector,
  questionsSelector,
  scoreSelector,
} from '../../../redux/selectors/quizz'

interface Props {
  winScore?: number
}

const QuizzScore: FunctionComponent<Props> = ({ winScore }) => {
  const questions = useSelector(questionsSelector)
  const currentQuestionIdx = useSelector(currentQuestionIdxSelector)
  const score = useSelector(scoreSelector)
  const remQuestions = questions.length - (currentQuestionIdx + 1)

  if (winScore && winScore > 0) {
    return (
      <>
        <div className="quizz-header">
          {remQuestions > 0 && (
            <span className="quizz-header-center">
              {remQuestions}{' '}
              {remQuestions > 1 ? 'essais restants' : 'essai restant'}
            </span>
          )}
          {remQuestions === 0 && (
            <span className="quizz-header-center">{tt('lp_finished')}</span>
          )}
        </div>
      </>
    )
  } else {
    return (
      <>
        <div className="quizz-header">
          <span className="quizz-header-left">
            {currentQuestionIdx + 1}/{questions.length}
          </span>
          <span className="quizz-header-right">
            {score}
            {score > 1 ? ' points' : ' point'}
          </span>
        </div>
      </>
    )
  }
}

export default QuizzScore
